import React from "react";
import SurveyResultsList from "./SurveyResultsList";

function SurveyDashboard() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
        minWidth: 0,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
          padding: "0",
        }}
      >
        <SurveyResultsList />
      </div>
    </div>
  );
}

export default SurveyDashboard;
